import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Box, Typography, Paper } from '@mui/material';

const sampleData = [
  { time: '2024-07-01', value1: 40, value2: 24 },
  { time: '2024-07-02', value1: 30, value2: 13 },
  { time: '2024-07-03', value1: 20, value2: 98 },
  { time: '2024-07-04', value1: 27, value2: 39 },
  { time: '2024-07-05', value1: 18, value2: 48 },
  { time: '2024-07-06', value1: 23, value2: 38 },
  { time: '2024-07-07', value1: 34, value2: 43 },
  { time: '2024-07-08', value1: 45, value2: 21 },
  { time: '2024-07-09', value1: 32, value2: 17 },
  { time: '2024-07-10', value1: 28, value2: 36 },
  { time: '2024-07-11', value1: 37, value2: 19 },
  { time: '2024-07-12', value1: 22, value2: 40 },
];

const OldFlex = () => {
  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h3" gutterBottom>
        Data Analytics
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 4 }}>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample</Paper>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample</Paper>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample</Paper>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            PV Production Data
          </Typography>
          <LineChart
            width={1200}
            height={400}
            data={sampleData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="value1" stroke="#8884d8" activeDot={{ r: 8 }} />
          </LineChart>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            Consumption Data
          </Typography>
          <LineChart
            width={1200}
            height={400}
            data={sampleData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="value2" stroke="#82ca9d" />
          </LineChart>
        </Box>
      </Box>

      <Typography variant="h3" gutterBottom sx={{ mt: 6 }}>
        Flexibility Analysis
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 4 }}>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample Value</Paper>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample Value</Paper>
        <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', width: '30%' }}>Sample Value</Paper>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
          <LineChart
            width={500}
            height={300}
            data={sampleData}
            margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="value1" stroke="#8884d8" activeDot={{ r: 8 }} />
          </LineChart>

          <LineChart
            width={500}
            height={300}
            data={sampleData}
            margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="value2" stroke="#82ca9d" />
          </LineChart>
        </Box>
      </Box>
    </Box>
  );
};

export default OldFlex;
